import { generateEmailParagraph, spaceDivider } from "../../generateEmailParagraph"

export const thankYou = `
${spaceDivider}
${generateEmailParagraph(`Děkujeme,`)}

${generateEmailParagraph(`
  Tým Vzdělání budoucnosti<br/>
  <a href="mailto:info@vzdelanibudoucnosti.cz" title="email Vzdělání budoucnosti" target="_blank">info@vzdelanibudoucnosti.cz</a><br/>
  <a href="https://vzdelanibudoucnosti.cz" title="web Vzdělání budoucnosti" target="_blank">vzdelanibudoucnosti.cz</a><br />
  Telefon: (+420) 774 889 639
`)}
`
